import { ReactComponent as Caret } from 'icons/caret-black.svg';
import { ReactComponent as CollapseAllIcon } from 'icons/collapse-all.svg';
import { ReactComponent as ExpandAllIcon } from 'icons/expand-all.svg';

const CARET_ICON_SIZE = 16;
const EXPAND_ALL_ICON_SIZE = 16;

/**
 * Reusable expander button component
 * @param {boolean} isExpanded - Whether the item is expanded
 * @param {Function} onClick - Click handler
 * @param {Object} customIcons - Custom icon components { expanded, collapsed }
 */
export const ExpandButton = ({
  isExpanded,
  onClick,
  width = CARET_ICON_SIZE,
  height = CARET_ICON_SIZE,
}) => (
  <button className="toggle-expanded" onClick={onClick}>
    {isExpanded ? (
      <Caret
        id="caret-icon--expanded"
        style={{ transform: 'rotate(90deg)' }}
        width={width}
        height={height}
      />
    ) : (
      <Caret id="caret-icon--collapsed" width={width} height={height} />
    )}
  </button>
);

export const ExpandAllButton = ({
  isExpanded,
  onClick,
  width = EXPAND_ALL_ICON_SIZE,
  height = EXPAND_ALL_ICON_SIZE,
}) => (
  <button className="toggle-expanded" onClick={onClick}>
    {isExpanded ? (
      <CollapseAllIcon
        id="expand-all-icon--expanded"
        width={width}
        height={height}
      />
    ) : (
      <ExpandAllIcon
        id="expand-all-icon--collapsed"
        width={width}
        height={height}
      />
    )}
  </button>
);
